import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { useEffect, useState } from "react";
import ButtonComponent from "../Inputs/ButtonComponent";
import TextReadOnlyCell from "./Cells/TextReadOnlyCell";
import CheckBoxReadOnlyCell from "./Cells/CheckBoxReadOnlyCell";

type TableComponentProps = {
  data: any;
  columns: any;
  className?: string;
  scrollable?: any;
  scrollHeight?: any;
  reorderColumns?: any;
  reorderRows?: any;
  reorderRowsChange?: (e?: any) => void;
  onClick?: (row?: any) => void;
  onButtonClick?: (row?: any, id?: any) => void;
};

//reorder 시 상위 props로 데이터 저장 로직 연결필요
export default function TableComponent(props: TableComponentProps) {
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    setDatas(props.data);
  }, [props.data]);

  const dynamicColumns = props.columns.map((col: any) => {
    const ButtonTemplate = (row: any) => {
      return (
        <ButtonComponent
          fullWidth
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            if (props.onButtonClick) {
              props.onButtonClick(row, col.field);
            }
          }}
          style={{
            backgroundColor: col.backgroundColor,
          }}
        >
          {col.buttonLabel}
        </ButtonComponent>
      );
    };

    const checkBoxReadOnlyTemplate = (row: any) => {
      return (
        <CheckBoxReadOnlyCell value={row[col.field] == 1 ? true : false} />
      );
    };

    const CustomTemplate = (row: any) => {
      return (
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (props.onClick) {
              props.onClick(row);
            }
          }}
        >
          {col.custom &&
            col.custom.filter(
              (item: any) => item.id == row[col.samevalue]
            )[0] &&
            col.custom.filter((item: any) => item.id == row[col.samevalue])[0][
              col.value
            ]}
        </div>
      );
    };

    const TextTemplate = (row: any) => {
      return (
        <TextReadOnlyCell
          value={row[col.field]}
          onClick={(e) => {
            e.stopPropagation();
            if (props.onClick) {
              props.onClick(row);
            }
          }}
        />
      );
    };

    return (
      <Column
        key={col.field}
        columnKey={col.field}
        field={col.field}
        header={col.header}
        body={
          col.type == "Button"
            ? ButtonTemplate
            : col.type == "CheckBoxReadOnly"
            ? checkBoxReadOnlyTemplate
            : col.type == "custom"
            ? CustomTemplate
            : TextTemplate
        }
        headerStyle={{
          textAlign: "center",
        }}
        bodyStyle={
          props.onClick
            ? {
                cursor: "pointer",
                maxWidth: col.width,
                overflow: "auto",
                textAlign: col.position ? col.position : "start",
              }
            : {
                maxWidth: col.width,
                overflow: "auto",
                textAlign: col.position ? col.position : "start",
              }
        }
        sortable={col.header ? true : false}
      />
    );
  });
  return (
    <div className="card">
      <DataTable
        value={datas}
        reorderableColumns={props.reorderColumns}
        reorderableRows={props.reorderRows}
        showGridlines
        onRowReorder={(e) => {
          if (props.reorderRowsChange) {
            props.reorderRowsChange(e.value);
          }
        }}
        className={props.className}
        scrollHeight={props.scrollHeight}
        scrollable={props.scrollable}
        tableStyle={{
          minWidth: "100%",
        }}
        size={"small"}
        resizableColumns
        columnResizeMode="expand"
      >
        {props.reorderRows && (
          <Column rowReorder style={{ width: "50px", textAlign: "center" }} />
        )}
        {dynamicColumns}
      </DataTable>
    </div>
  );
}
